module.exports = __webpack_public_path__ + "static/media/logo.0d6e761d.png";